import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Select,
  Form,
  DatePicker,
  Col,
  Divider,
  Button,
  Spin,
  Tooltip,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { LeftOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../configurations.config";
import CustomButton from "../../../components/custom/CustomButton";
import dayjs from "dayjs";

const { Text } = Typography;
const { TextArea } = Input;

const WorkingDays = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  // const { state } = useLocation();
  const [paymentTypeDetail, setPaymentTypeDetail] = useState([]);
  const [repaymentRescheduleData, setRepaymentRescheduleData] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getWorkingDays();
  }, []);

  function getWorkingDays() {
    const url = `${apiConfig.Workingdays}`;
    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;

        let tempRepaymentRescheduleOptions = [];

        const recurrenceString = objList.recurrence;
        const match = recurrenceString.match(/BYDAY=([^;]+)/);
        const selectedDays = match ? match[1].split(",") : [];
        // console.log(selectedDays.includes("TU"));

        useForm.setFieldsValue({
          repaymentRescheduleType: objList?.repaymentRescheduleType.id,
          extendTermForDailyRepayments: objList?.extendTermForDailyRepayments,
          monday: selectedDays.includes("MO") ? true : false,
          tuesday: selectedDays.includes("TU") ? true : false,
          wednesday: selectedDays.includes("WE") ? true : false,
          thursday: selectedDays.includes("TH") ? true : false,
          friday: selectedDays.includes("FR") ? true : false,
          saturday: selectedDays.includes("SA") ? true : false,
          sunday: selectedDays.includes("SU") ? true : false,
        });

        objList?.repaymentRescheduleOptions?.forEach((element) => {
          tempRepaymentRescheduleOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        setRepaymentRescheduleData(tempRepaymentRescheduleOptions);
        setPaymentTypeDetail();
      }
    });
    setIsLoading(false);
  }

  function onCancel() {
    navigate("/dashboard");
  }

  const onSubmit = (formValues) => {
    const daysMap = {
      monday: "MO",
      tuesday: "TU",
      wednesday: "WE",
      thursday: "TH",
      friday: "FR",
      saturday: "SA",
      sunday: "SU",
    };

    // Filtering out the selected days (true values)
    const selectedDays = Object.keys(daysMap).filter(
      (day) => formValues[day] === true
    );

    const recurrence = `FREQ=WEEKLY;INTERVAL=1;BYDAY=${selectedDays
      .map((day) => daysMap[day])
      .join(",")}`;

    const url = `${apiConfig.Workingdays}`;

    const {
      monday,
      tuesday,
      wednesday,
      thursday,
      friday,
      saturday,
      sunday,
      ...rest
    } = formValues;

    const body = {
      ...rest,
      recurrence,
      method: "PUT",
      locale: "en",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.updateWorkingDaysMsg);
        // navigate("/manage-payment-type");
        getWorkingDays();
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      //   onView={handleOnView}
    >
      <TopContent
        pageTitle={labelConfig.workingDays}
        pageItems={staticConfig.manageworkingDaysItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={useForm} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.monday} name="monday">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.monday,
                      "select"
                    )}
                    options={staticConfig.yesOrNoData}
                    showSearch
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.tuesday} name="tuesday">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.tuesday,
                      "select"
                    )}
                    options={staticConfig.yesOrNoData}
                    showSearch
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.wednesday} name="wednesday">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.wednesday,
                      "select"
                    )}
                    options={staticConfig.yesOrNoData}
                    showSearch
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.thursday} name="thursday">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.thursday,
                      "select"
                    )}
                    options={staticConfig.yesOrNoData}
                    showSearch
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.friday} name="friday">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.friday,
                      "select"
                    )}
                    options={staticConfig.yesOrNoData}
                    showSearch
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.saturday} name="saturday">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.saturday,
                      "select"
                    )}
                    options={staticConfig.yesOrNoData}
                    showSearch
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.sunday} name="sunday">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.sunday,
                      "select"
                    )}
                    options={staticConfig.yesOrNoData}
                    showSearch
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={
                    <Tooltip title={labelConfig.paymentsDueOnNonWorkingDays}>
                      {BOM.SubstringFormat(
                        labelConfig.paymentsDueOnNonWorkingDays,
                        20
                      )}
                    </Tooltip>
                  }
                  name="repaymentRescheduleType"
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.paymentsDueOnNonWorkingDays,
                      "select"
                    )}
                    options={repaymentRescheduleData}
                    showSearch
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={
                    <Tooltip title={labelConfig.extendTermForLoans}>
                      {BOM.SubstringFormat(labelConfig.extendTermForLoans, 20)}
                    </Tooltip>
                  }
                  name="extendTermForDailyRepayments"
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.extendTermForLoans,
                      "select"
                    )}
                    options={staticConfig.yesOrNo}
                    showSearch
                    allowClear
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Divider />
              {BOM.HasPermission("UPDATE_WORKINGDAYS") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
              )}

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default WorkingDays;
